export const getDaysInThePast = (startDate: Date, dateInPast: string) => {
  const diffInTime = startDate.getTime() - new Date(dateInPast).getTime()
  return Math.round(diffInTime / (1000 * 3600 * 24))
}
